import axiosClient from './axiosClient';

// Mock authentication API
export const authApi = {
  // Login
  login: async (email, password) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        // Mock validation
        if (email && password) {
          const user = {
            id: Math.floor(Math.random() * 1000),
            name: email.split('@')[0],
            email,
            role: email.includes('partner') ? 'partner' : 'user',
            phone: '+91 9876543210',
            avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
          };
          
          resolve({
            success: true,
            user,
            token: `mock_jwt_token_${Date.now()}`,
            message: 'Login successful',
          });
        } else {
          reject({
            response: {
              data: { message: 'Invalid credentials' },
            },
          });
        }
      }, 800);
    });
  },

  // Register
  register: async (userData) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const user = {
          id: Math.floor(Math.random() * 1000),
          name: userData.name,
          email: userData.email,
          role: userData.role || 'user',
          phone: userData.phone,
          avatar: userData.role === 'partner' 
            ? 'https://randomuser.me/api/portraits/women/44.jpg'
            : 'https://randomuser.me/api/portraits/men/22.jpg',
        };
        
        resolve({
          success: true,
          user,
          token: `mock_jwt_token_${Date.now()}`,
          message: 'Registration successful',
        });
      }, 1000);
    });
  },

  // Get user bookings
  getUserBookings: async () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          bookings: [
            {
              id: 1,
              service: 'Cleansing Therapy',
              status: 'completed',
              date: '2025-10-28',
              time: 'Morning (8 AM - 12 PM)',
              partner: {
                name: 'Dr. Priya Sharma',
                image: 'https://randomuser.me/api/portraits/women/44.jpg',
                rating: 4.8,
              },
              location: 'Bangalore, Karnataka',
            },
            {
              id: 2,
              service: 'Cleansing Therapy',
              status: 'accepted_by_partner',
              date: '2025-11-05',
              time: 'Afternoon (12 PM - 4 PM)',
              partner: {
                name: 'Dr. Amit Patel',
                image: 'https://randomuser.me/api/portraits/men/32.jpg',
                rating: 4.9,
              },
              location: 'Bangalore, Karnataka',
            },
          ],
        });
      }, 500);
    });
  },

  // Logout
  logout: async () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ success: true });
      }, 200);
    });
  },
};

export default authApi;
